<template>
  <div class="main">
    <router-view></router-view>
    <div class="collapse-box" :style="{backgroundImage: 'url(' + Holder + ')' }" @click="handleCollapse">
      <i  :class="isCollapse ? 'el-icon-arrow-right' : 'el-icon-arrow-left'"></i>
    </div>
  </div>
</template>
<script>
import Holder from '@/assets/css/holder.svg'
export default {
  components: {},
  data(){
    return{
      Holder: Holder,
      isCollapse: false
    }
  },
  methods:{
     //折叠菜单栏
     handleCollapse(){
      this.isCollapse = !this.isCollapse;
      this.$emit('onCollapse',this.isCollapse);
    },
  }
}
</script>
<style lang="scss" scoped>
.main{
  width: 100%;
  height: 100%;
  position: relative;
  .collapse-box{
    top: calc(50vh - 46px);
    position: absolute;
    width: 12px;
    height: 56px;
    top: 50%;
    left: -20px;
    background: url(/@/asssts/css/holder.svg);
    -webkit-transform: translate(0, -50%);
    transform: translate(0, -50%);
    cursor: pointer;
  }
  .collapse-box i{
    margin-top: 19px;
    margin-left: -3px;
    color: #B7BDC8;
    font-size: 18px;
  }
}
</style>